import * as React from 'react';
import { Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';

interface Properties {
  crumbs?: Crumb[];
  children: React.ReactNode;
}
interface Crumb {
  name: string;
  link: string;
}

export function PageHeader({ crumbs, children }: Properties) {
  return (
    <React.Fragment>
      <h1 className='display-6 mt-3'>{children}</h1>
      {crumbs?.length > 1 && (
        <Breadcrumb>
          {crumbs?.map((crumb, index) => (
            <Breadcrumb.Item
              key={index}
              active={index == crumbs.length - 1 ? true : false}
              linkAs={Link}
              linkProps={{ to: crumb.link }}
            >
              {crumb.name}
            </Breadcrumb.Item>
          ))}
        </Breadcrumb>
      )}
    </React.Fragment>
  );
}
